"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _algoliaService = require("../../services/algoliaService");

var _algolia = require("@insided/shared/services/algolia");

var _common = require("@insided/shared/utils/common");

var DEFAULT_PAGE = 1;
var DEFAULT_PAGE_SIZE = 25;

var TagsIndex = /*#__PURE__*/function () {
  function TagsIndex() {
    var _this = this;

    (0, _classCallCheck2.default)(this, TagsIndex);
    (0, _defineProperty2.default)(this, "index", void 0);
    (0, _defineProperty2.default)(this, "cb", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(data) {
        var client, indexName;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _algolia.createAlgoliaClient)(data.client_id, data.token);

              case 2:
                client = _context.sent;
                indexName = (0, _globals.default)('communityId') + (_common.common.isModuleActive('unifiedIndexEnabled') ? '-unified' : '-tags');
                _this.index = client.initIndex(indexName);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    this.cb = this.cb.bind(this);
  }

  (0, _createClass2.default)(TagsIndex, [{
    key: "setupIndex",
    value: function () {
      var _setupIndex = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _algoliaService.getSearchToken)(this.cb);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setupIndex() {
        return _setupIndex.apply(this, arguments);
      }

      return setupIndex;
    }()
  }, {
    key: "searchByName",
    value: function () {
      var _searchByName = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(name) {
        var page,
            pageSize,
            searchRequest,
            _args3 = arguments;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                page = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : DEFAULT_PAGE;
                pageSize = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : DEFAULT_PAGE_SIZE;

                if (this.index) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return this.setupIndex();

              case 5:
                searchRequest = {
                  restrictSearchableAttributes: ['name'],
                  page: page - 1,
                  hitsPerPage: pageSize
                };

                if (_common.common.isModuleActive('unifiedIndexEnabled')) {
                  searchRequest.filters = 'gs_data_source:tags';
                }

                return _context3.abrupt("return", this.index.search(name, searchRequest));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function searchByName(_x2) {
        return _searchByName.apply(this, arguments);
      }

      return searchByName;
    }()
  }, {
    key: "getFirstRecordsFromNextPage",
    value: function () {
      var _getFirstRecordsFromNextPage = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(currentPage) {
        var pageSize,
            length,
            _args4 = arguments;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                pageSize = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : DEFAULT_PAGE_SIZE;
                length = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : 1;

                if (this.index) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 5;
                return this.setupIndex();

              case 5:
                return _context4.abrupt("return", this.index.search('', {
                  restrictSearchableAttributes: ['name'],
                  offset: currentPage * pageSize,
                  length: length
                }));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getFirstRecordsFromNextPage(_x3) {
        return _getFirstRecordsFromNextPage.apply(this, arguments);
      }

      return getFirstRecordsFromNextPage;
    }()
  }, {
    key: "clearCache",
    value: function clearCache() {
      if (!this.index) {
        return;
      }

      this.index.clearCache();
    }
  }]);
  return TagsIndex;
}();

exports.default = TagsIndex;